import { useState, useEffect } from 'react';
import useSWR from 'swr';

import { FacebookPost } from '@/lib/types';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';

import { hookMessages } from './messages';
import { getFacebookFeeds } from '@/services/facebook';

// empty response page id 61559569618059 Adam-Une
export const useFacebookFeeds = (pageId: string) => {
  const [posts, setPosts] = useState<FacebookPost[]>([]);

  const {
    data: facebookFeedsResponse,
    isLoading,
    isValidating,
  } = useSWR(pageId ? getFacebookFeeds(pageId) : null, {
    onError: (error) => {
      enqueueSnackbar(hookMessages['hooks.facebookFeed.fetchError'], {
        variant: 'error',
      });
      console.error('[BREEDLOGIC] useFacebookFeeds fetch error:', error);
    },
  });

  useEffect(() => {
    if (facebookFeedsResponse) {
      setPosts(facebookFeedsResponse.data);
    }
  }, [facebookFeedsResponse, isLoading, isValidating]);

  const isLoadingOrValidating = isLoading || isValidating;
  return { posts, isLoadingOrValidating };
};
